import Loader from "./Loader";

export type { ILoaderProps } from "./Loader";

export default Loader;
